module.exports = __webpack_public_path__ + "img/neo.197e52e3.webp";